import React, { Component } from 'react'

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import AddEditIssue from "../../views/issues/AddEditIssue";
import Alert from 'react-s-alert';
import { currentPage, itemPerPage } from "../../constants/index";
import NDF from '../noDataFound'

import Pagination from '@material-ui/lab/Pagination';
import Grid from '@material-ui/core/Grid';
import { Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

//Actions
import { getAllIssues, delIssue, getIssuesByCommunity, delIssueByCommunity } from '../../actions/issueAction.js';
import { SetHeaderButtons } from '../../actions/headerButtonsActions';


//Engage Components
import { SweetConfirmationAlert } from '../../components/Alert/sweetAlert';

class Issue extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            tableData: [
            ],
            isLoading: false,
            currentPage: currentPage,
            itemPerPage: itemPerPage,

            //Community
            superUserCommunitySelected: undefined,
            superUserIssuesLoaddedForCommunity: undefined,
            openCommunityCombo: false,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        if (localStorage.getItem('superAdmin') === "false") {

            this.getIssues();
        }
        this.SetHeaderButtons();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));

        // this.props.SetHeaderButtons(undefined);
    }

    SetHeaderButtons = (open = false) => {
        const headerButtons = this.getHeaderButtons(open);
        this.props.SetHeaderButtons(headerButtons)
    }

    getHeaderButtons = (open = false) => {
        const communityIdExist = !!(localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0);

        const styles = {
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
        }

        return (
            <Grid container className='setupInfoSection' style={styles.globalActions}>
                {
                    !open ?
                        <Grid item container justify='flex-end' alignItems='center' style={styles.globalActions}>
                            {/* {
                          (isSuperAdmin && isSuperAdmin === true)?
                          <Grid item  xs={4} style={{backgroundColor:'#009EDD' ,border:'1px solid #009EDD', borderRadius:'25px',paddingLeft:'15px', marginRight:'15px', height:'39px'}} justify='center'>
                              <SimpleSelect
                                  label={'Community'}
                                  onChangeHandler = {
                                      (evet, newItem) => 
                                      {
                                          if(newItem !== null && newItem !== ''){ 
                                              localStorage.setItem('communityId',newItem.communityId);
                                              this.setState({superUserCommunitySelected: newItem});
                                          } else{
                                              this.setState({ superUserCommunitySelected:undefined} );
                                              localStorage.removeItem('communityId');
                                          
                                          }
                                      }
                                  }
                                  optionsItemsIconsData = {this.props.communityData? this.props.communityData : []}
                                  selected = {this.state.superUserCommunitySelected? this.state.superUserCommunitySelected :{}}
                                  disabled= {false}
                              />
                          </Grid>
                          :
                          undefined 
                      } */}
                      <Grid
                          id='issues_btn_add' 
                          item  xs={6} sm={5} md={3} lg={3}
                          disabled={!communityIdExist} 
                          className={!communityIdExist?"appbtn-engage disabledSkybluebtn-engage appbtn-list-engage appbtnBarButton":"appbtn-engage skybluebtn-engage appbtn-list-engage appbtnBarButton"}
                          onClick={this.addIssue} 
                      >
                          New Issue
                      </Grid> 
                      {/* <div className="appbtn-engage skybluebtn-engage appbtn-list-engage" onClick={this.addIssue} style={styles.globalActions}>
                              New Issue
                      </div>  */}
                        </Grid>
                        :
                        <div id='issues_btn_save' className="appbtn-list-engage" style={styles.globalActions}>
                            <div className="appbtn-engage skybluebtn-engage appbtnBarButton" onClick={this.SaveIssue}>
                                Save
                            </div>
                            {/* <div className="appbtn-engage redbtn-engage" onClick={this.CancelIssue}>
                          Cancel
                      </div>                                                         */}
                        </div>

                }
            </Grid>
        )
    }


    getIssues = () => {
        this.props.getIssuesByCommunity(localStorage.getItem('communityId'));
    }

    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });
    }


    handleDeleteClick = async (e, data, index) => {

        const title = 'Are you sure you want to delete the Issue?';

        const { isConfirmed } = await SweetConfirmationAlert(title, 'alert_deleteIssue');

        if (isConfirmed) {
            this.deleteWorkOrder({}, data);
        }


        // Alert.warning('Are you sure you want to delete the Issue?', {
        //     position: 'bottom-right',
        //     effect: 'slide',
        //     timeout: 10000,
        //     customFields: {
        //         displayComponent: true,
        //         handleButtonClick: this.deleteWorkOrder,
        //         id: data,
        //     },
        // });

    }

    deleteWorkOrder = (event, item, isActive) => {

        if (item._id) {
            this.props.delIssueByCommunity(item._id);
        }

        const lastPage = Math.ceil((this.props.tableData.length - 1) / this.state.itemPerPage);

        if (this.state.currentPage > lastPage) {
            this.handlePageChange(lastPage);
        }

        Alert.closeAll();
    }

    addIssue = () => {
        this.setState({ open: true, issue: '' })
        this.SetHeaderButtons(true);


        if (this.props?.handlerOpenElementDetails) {
            this.props.handlerOpenElementDetails();
        }
        this.props.openAddIssue();

    };

    CancelIssue = () => {
        var link = document.getElementById('cancel_btn_issues');
        link.click();
        this.props.closeAddIssue();

    }

    SaveIssue = () => {
        var link = document.getElementById('save_btn_issues');
        link.click();
        this.props.closeAddIssue();
    }

    editIssue = (e, item, index) => {

        if (this.props?.handlerOpenElementDetails) {
            this.props.handlerOpenElementDetails();
        }

        this.setState({ issue: item, open: true });
        this.SetHeaderButtons(true);
        this.props.openAddIssue();
    }

    handleClose = (pageNextIssue = 0) => {

        this.setState({ open: false });
        this.SetHeaderButtons(false);

        if (pageNextIssue > 0) {
            this.handlePageChange(pageNextIssue);
        }

        if (localStorage.getItem('communityId')) {
            setTimeout(() => { this.getIssues(); }, 200);
        }


        if (this.props.handlerCloseElementDetails) {
            this.props.handlerCloseElementDetails()
        }

        this.props.closeAddIssue();
    };

    handlePageChange = (number) => {

        if (number && typeof (number) == 'number' && number > 0) {
            this.setState({
                currentPage: Number(number)
            });
        }

    };

    GetCommunityObjectForSupuerUserCombo(communityId) {
        let communityObj = null;
        if (this.props.communityData) {

            communityObj = this.props.communityData.find(item => item.communityId === communityId);
        }

        return communityObj;
    };
    handleCommunityCombo = () => {
        this.setState((prevState) => ({ openCommunityCombo: !prevState.openCommunityCombo }));
    }
    handleCommunityOnBlur = () => {
        this.setState({ openCommunityCombo: false })
    }


    //#region  Inner Components
    IssueList = () => {
        const currentPage = this.state.currentPage;
        const itemPerPage = this.state.itemPerPage;
        const indexOfLastTodo = currentPage * itemPerPage;
        const indexOfFirstTodo = indexOfLastTodo - itemPerPage;
        const currentData = this.props.tableData && this.props.tableData.length ? this.props.tableData.slice(indexOfFirstTodo, indexOfLastTodo) : [];

        const totalIssues = this.props.tableData && this.props.tableData.length;

        const displayHeaders = this.state.isMobile ? 'none' : 'flex';

        //styles
        const styles = {
            title: {
                flexGrow: 1
            },
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
            disabledButton: {
                backgroundColor: 'white'
            },
            DeleteButton: {
                backgroundColor: '#DB5B70'
            }
        };

        return (
            <Grid container >
                <Grid container style={{ flexGrow: 1, display: displayHeaders }} >
                    <Grid item xs={8} className='defaultTextStyles'>Issue</Grid>
                    <Grid item xs={2} className='defaultTextStyles'>Edit</Grid>
                    <Grid item xs={2} className='defaultTextStyles'>Remove</Grid>
                </Grid>
                <Grid container>
                    {currentData && currentData.map((item, index) => {
                        return (

                            //  style={{backgroundColor:'#1f1f1f', padding:'5px', borderRadius:'4px', marginTop:'6px'}}
                            <Grid id={`issues_row_${item._id}`} container key={index} className='rowEngageStyleList cursorDefault' alignContent='center' style={{ backgroundColor: '#1f1f1f', padding: '5px', marginTop: '6px' }}>
                                <Grid item xs={12} sm={12} md={8} style={{ textAlign: 'center' }} id={`issues_row_${item._id}_name`}>{item.name}</Grid>
                                {/* className='EngageButonClass' style={{alignContent:'center', display:'flex', justifyContent:'center'}} */}
                                <Grid item xs={12} sm={12} md={2} className='EngageButonClass' style={{ alignContent: 'center', display: 'flex', justifyContent: 'center' }}>
                                    <Button
                                        id={`issues_edit_btn_${item._id}`}
                                        variant="contained"
                                        value={item._id}
                                        color='secondary'
                                        onClick={(e) => {
                                            this.editIssue(e, item);
                                        }}>
                                        <EditIcon />
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={12} md={2} >
                                    <Button
                                        id={`issues_delete_btn_${item._id}`}
                                        variant="contained"
                                        value={item._id}
                                        color='secondary'
                                        style={styles.DeleteButton}
                                        onClick={(e) => {
                                            this.handleDeleteClick(e, item);
                                        }}>
                                        <DeleteIcon />
                                    </Button>
                                </Grid>

                            </Grid>
                        )
                    }
                    )}

                    <div style={{ marginLeft: 'auto', marginRight: '0' }} >
                        <Grid item xs={12} >
                            {
                                currentData && currentData.length ?
                                    <Pagination
                                        count={Math.ceil(totalIssues / itemPerPage)}
                                        defaultPage={1}
                                        onChange={(e, item) => { this.handlePageChange(item) }}
                                        page={currentPage}
                                        showFirstButton
                                        showLastButton
                                        siblingCount={1}
                                        boundaryCount={1}
                                    />
                                    :
                                    <NDF />
                            }
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        )
    };
    //#endregion

    setIdsPaginationHandler = () => {
        try {
            const pagContainer = document.getElementsByClassName('MuiPagination-ul');
            if (pagContainer && pagContainer.length > 0 && pagContainer[0]) {
                const pag = pagContainer[0];
                const liElements = pag.getElementsByTagName('li');
                if (liElements && liElements.length >= 4) {
                    for (let i = 0; i < liElements.length; i++) {
                        liElements[i].removeAttribute('id')
                    }
                    const btn_GoToFist = liElements[0];
                    if (btn_GoToFist) {
                        btn_GoToFist.setAttribute('id', 'pag_btn_gotofirst');
                        btn_GoToFist.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_back = liElements[1];
                    if (btn_back) {
                        btn_back.setAttribute('id', 'pag_btn_goback');
                        btn_back.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_forward = liElements[liElements.length - 2];
                    if (btn_forward) {
                        btn_forward.setAttribute('id', 'pag_btn_goforward');
                        btn_forward.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_GoToLast = liElements[liElements.length - 1];
                    if (btn_GoToLast) {
                        btn_GoToLast.setAttribute('id', 'pag_btn_gotolast');
                        btn_GoToLast.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }

                    for (let i = 2; i < liElements.length - 2; i++) {
                        const btn = liElements[i].getElementsByTagName('button');

                        if (btn && btn.length > 0 && btn[0] && btn[0].textContent.length > 0) {
                            liElements[i].setAttribute('id', `pagElement_${btn[0].textContent}`);
                        }
                    }
                }
            }
        } catch (err) { }
    }

    render() {

        //Set IDS PAGINATION
        setTimeout(() => {
            this.setIdsPaginationHandler();
        }, 100);

        const isSuperAdmin = localStorage.getItem('superAdmin') ? (localStorage.getItem('superAdmin') === "true") : false;

        if (isSuperAdmin && localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0 && this.state.superUserCommunitySelected === undefined) {
            this.setState({ superUserCommunitySelected: this.GetCommunityObjectForSupuerUserCombo(localStorage.getItem('communityId')) });
        }

        if (
            (
                this.state.superUserCommunitySelected &&
                (
                    !this.state.superUserIssuesLoaddedForCommunity ||
                    (this.state.superUserIssuesLoaddedForCommunity !== this.state.superUserCommunitySelected)
                )
            ) ||
            (
                this.state.superUserCommunitySelected === undefined &&
                this.state.superUserIssuesLoaddedForCommunity !== undefined
            )
        ) {
            this.getIssues();
            this.setState({ superUserIssuesLoaddedForCommunity: this.state.superUserCommunitySelected });
            this.setState({ currentPage: 1 });
        }

        const currentPage = this.state.currentPage;
        const itemPerPage = this.state.itemPerPage;
        
        const totalIssues = this.props.tableData && this.props.tableData.length;
        const lastPage = Math.ceil(totalIssues / itemPerPage);
        const pageNextIssue = totalIssues % itemPerPage === 0 ? lastPage + 1 : lastPage;

        return (
            <Grid container>
                <main className="content-engage" style={{ paddingTop: '15px' }}>
                    <Grid item container className='PageTitle' justify='center' alignContent='center'>
                        {
                            this.state.open ?
                                undefined
                                :
                                <Grid item id='issues_title'>
                                    Issues ({totalIssues})
                                </Grid>
                        }
                    </Grid>
                    <Grid item container>
                    {
                        this.state.open ? 
                        <AddEditIssue closeDialog={this.handleClose} data={this.state.issue} newItemPage = {pageNextIssue} currentPage= {currentPage}  
                            characterLimit={this.props.characterLimit}
                            openTranslation={this.props.addTranslations}   
                            closeTranslations={this.props.closeTranslations}     
                        /> 
                        :
                        <this.IssueList/>
                    }
                    </Grid>
                </main>
            </Grid>
        )
    }
}

function mapStateToProps(state, dispatch) {
    let communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId })) : [];
    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }

    return {
        tableData: state.issueReducer && state.issueReducer.issueData,
        communityData: communityData,
    }
}

Issue = reduxForm({
    form: 'DeviceForm',
    // validate,
    enableReinitialize: true,
})(Issue);

export default connect(mapStateToProps, { getAllIssues, delIssue, getIssuesByCommunity, delIssueByCommunity, SetHeaderButtons })(Issue);
